import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Stick from 'react-stick';
import useResizeObserver from 'use-resize-observer';
import cn from 'classnames';
import { Icon } from '@pwc/pwc-deals-ui';
import styles from './styles.module.scss';
import SVGScalingControls from '../SVGScalingControls';

type TPropsSVGScalingControls = React.ComponentProps<typeof SVGScalingControls>;

interface IPropsButtonMainAction {
  readonly propsRoot: React.ButtonHTMLAttributes<HTMLButtonElement>;
}

const ButtonMainAction: React.FC<IPropsButtonMainAction> = ({ propsRoot }) => {
  const { ref } = useResizeObserver<HTMLButtonElement>();
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line react/button-has-type
    <button ref={ref} {...propsRoot}>
      <Icon
        name="resize"
        className="fill icon-orange"
        width="16px"
        data-testid="resize-icon"
      />
      <span className={styles.labelResize} data-testid="resize-button">
        {t('resize')}
      </span>
    </button>
  );
};

interface IProps {
  readonly propsSVGScalingControls?: TPropsSVGScalingControls;
  readonly isDarkMode: boolean;
  readonly isDisabled?: boolean | undefined;
}

const SVGScalingBase: React.FC<IProps> = ({
  propsSVGScalingControls,
  isDarkMode,
  isDisabled,
}) => {
  const [isMenuActive, setIsMenuActive] = useState<boolean>(false);
  // Fix for SVG Scaling, initial load to calculate svg scale
  const valueSVGScale = propsSVGScalingControls?.valueSVGScale || 100;
  return (
    <Stick
      align="top right"
      className={cn(styles.root, {
        [styles.rootDisabled]: isDisabled,
      })}
      node={
        isMenuActive ? (
          <div data-testid="scaling-controls">
            <SVGScalingControls
              {...propsSVGScalingControls}
              propsRoot={{
                ...propsSVGScalingControls?.propsRoot,
                style: {
                  ...propsSVGScalingControls?.propsRoot?.style,
                },
              }}
              valueSVGScale={valueSVGScale.toString()}
              isDarkMode={isDarkMode}
            />
          </div>
        ) : null
      }
      onClickOutside={() => {
        if (isMenuActive) {
          setIsMenuActive(false);
        }
      }}
      position="bottom center"
      updateOnAnimationFrame
    >
      <>
        <ButtonMainAction
          propsRoot={{
            className: cn(
              styles.objectWrapper,
              isDarkMode ? styles.SVGDark : styles.SVFLight
            ),
            onClick: () => {
              setIsMenuActive((prevState) => !prevState);
            },
            type: 'button',
          }}
        />
      </>
    </Stick>
  );
};

export default SVGScalingBase;
